import React from 'react';
import { Collapse, IconButton } from "@material-ui/core";
import { Alert as AlertMessage } from "@material-ui/lab";
import CloseIcon from '@material-ui/icons/Close';

const Alert = (props) => {
  let timeout = undefined;
  if (timeout) {
    clearTimeout(timeout);
  }
  if (props.timeOut && props.open) {
    timeout = setTimeout(() => {
      props.onChange(false);
    }, props.timeOut * 1000);
  }
  let actions = undefined;
  if (!props.canClose === false) {
    actions = (
      <IconButton
        aria-label="close"
        color="inherit"
        size="small"
        onClick={() => {
          if (timeout) {
            clearTimeout(timeout);
          }
          if (props.onChange) {
            props.onChange(false);
          }
        }}
      >
        <CloseIcon fontSize="inherit" />
      </IconButton>
    );
  }

  const handleClick = (event) => {
    if (props.id) {
      const element = document.getElementById(props.id);
      if (element && element.focus && typeof element.focus === "function")
        element.focus();
    }
  }

  return (
    <div style={{textAlign: "center", cursor: `${props.id ? "pointer" : "auto"}`}} onClick={handleClick}>
      <Collapse in={props.open}>
        <AlertMessage
          severity={props.severity?props.severity:"info"}
          action={actions}
        >
          {props.message}
        </AlertMessage>
      </Collapse>
    </div>
  )
}

export default Alert;
